<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="RedeemCodeBundleList" 
          :extra-items="[
            '優惠券使用紀錄'
          ]" 
        />
      </div>
    </div>
    <BelongedRedeemCode/>
  </div>
</template>

<script>
import BelongedRedeemCode from "@/components/Dashboard/RedeemCodeBundle/BelongedRedeemCode.vue"
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    BelongedRedeemCode,
    BreadCrumb
  }
};
</script>
